import Validator from 'fastest-validator';

export default function validateEmail(email: string) {
  const schema = {
    $$root: true,
    type: 'email',
    mode: 'precise',
  };
  const check = new Validator().compile(schema);

  return check(email);
}
